import moment from 'moment-business-days';

// Set custom US holidays
moment.updateLocale('us', {
  holidays: [
    '2024-01-01', // New Year's Day
    '2024-07-04', // Independence Day
    '2024-12-25', // Christmas Day
  ],
  holidayFormat: 'YYYY-MM-DD',
});

export function dateAfterBusinessDays(days: number): moment.Moment {
  const startDate = moment();
  return startDate.businessAdd(days);
}

export function formatLongDate(date: Date | undefined | null): string | undefined {
  return moment(date)?.format('MMMM, D, YYYY');
}

export function formatShortDate(date: Date | undefined | null): string | undefined {
  return moment(date)?.format('MM/DD/YYYY');
}

export function formatMiddleDate(date: Date | undefined | null): string | undefined {
  return moment(date)?.format('MMM D, YYYY');
}

// Specific to service choice and delivery date estimate.
const today = moment();
export const standardDeliveryDate = dateAfterBusinessDays(70);
export const premiumDeliveryDate = dateAfterBusinessDays(40);
export const premiumDateInWeeks = premiumDeliveryDate.diff(today, 'weeks');
